/**
 * @fileoverview Molecule: the recovery choices offered on an error screen.
 * @module components/molecules/ErrorActions
 */

import { useNavigate } from "react-router-dom"

import { Button } from "@/components/atoms"

import "./ErrorActions.css"

/** Props accepted by {@link ErrorActions}. */
export interface ErrorActionsProps {
	/**
	 * Retry callback. When provided, a "Réessayer" action is offered —
	 * used by the render boundary, which can reset instead of navigating.
	 */
	readonly onRetry?: (() => void) | undefined
}

/**
 * Recovery actions: retry, go back, go home.
 *
 * @param props - Optional retry callback.
 * @returns The rendered navigation block.
 */
export function ErrorActions({ onRetry }: ErrorActionsProps) {
	const navigate = useNavigate()

	return (
		<nav className="error-actions" aria-label="Navigation de récupération">
			{onRetry !== undefined && (
				<Button
					onClick={onRetry}
					ariaLabel="Réessayer l’action"
					size="lg"
				>
					Réessayer
				</Button>
			)}
			<Button
				variant="secondary"
				size="lg"
				ariaLabel="Retourner à l’accueil"
				onClick={() => {
					void navigate("/")
				}}
			>
				Retour à l’accueil
			</Button>
			<Button
				variant="ghost"
				size="lg"
				ariaLabel="Retourner à la page précédente"
				onClick={() => {
					void navigate(-1)
				}}
			>
				Page précédente
			</Button>
		</nav>
	)
}
